import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PMSPartner, PMSPartnerClientHinge, PMSPartnerUser } from '../models/pmspartner';

@Injectable({
  providedIn: 'root'
})
export class PmsManagementService {
  pmsPartners: PMSPartner[];
  constructor(private http: HttpClient, private toast: ToastrService) { }

  public GetPMSPartnerUsers(): Observable<PMSPartnerUser[]> {
    return this.http.get<PMSPartnerUser[]>(environment.baseURl + '/api/PMSPartner/user/list');
  }

  public GetPartnerMappings(userId: number): Observable<PMSPartnerClientHinge[]> {
    return this.http.get<PMSPartnerClientHinge[]>(environment.baseURl + '/api/PMSPartner/mapping/list/' + userId);
  }

  public GetPMSPartners(): Observable<PMSPartner[]> {
    return this.http.get<PMSPartner[]>(environment.baseURl + '/api/PMSPartner/partner/list');
  }

  public CreatePMSUser(u: PMSPartnerUser): Observable<PMSPartnerUser> {
    return this.http.post<PMSPartnerUser>(environment.baseURl + '/api/PMSPartner/user/create', u);
  }

  public DisablePMSUser(u: PMSPartnerUser): Observable<any> {
    return this.http.post<PMSPartnerUser>(environment.baseURl + '/api/PMSPartner/user/disable', u);
  }

  public CreateClientMapping(pch: PMSPartnerClientHinge): Observable<any> {
    return this.http.post<PMSPartnerClientHinge>(environment.baseURl + '/api/PMSPartner/mapping/create', pch);
  }

  public DeleteClientMapping(pch: PMSPartnerClientHinge): Observable<any> {
    return this.http.post<PMSPartnerClientHinge>(environment.baseURl + '/api/PMSPartner/mapping/delete', pch);
  }

  public CreatePMSPartner(partner: PMSPartner): Observable<PMSPartner> {
    return this.http.post<PMSPartner>(environment.baseURl + '/api/PMSPartner/partner', partner);
  }

}
